import { Container, Tabs, SimpleGrid, Button, Group, createStyles, Text, rem } from "@mantine/core"
import { DirectionCard } from "shared/ui/DirectionCard"
import { allEvents } from "./config"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  inner: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },

  description: {
    fontSize: theme.fontSizes.lg,

    [theme.fn.smallerThan("md")]: {
      fontSize: theme.fontSizes.md,
    },

    [theme.fn.smallerThan("sm")]: {
      fontSize: theme.fontSizes.sm,
    },
  },

  button: {
    marginTop: `calc(${theme.spacing.xl} * 2)`,

    [theme.fn.smallerThan("md")]: {
      marginTop: rem(32),
    },

    [theme.fn.smallerThan("xs")]: {
      marginTop: theme.spacing.xl,
    },
  },

  tab: {
    background: theme.fn.gradient({ from: theme.colors.indigo[3], to: theme.colors.cyan[3] }),

    color: theme.white,

    "&[data-active]": {
      background: theme.fn.gradient({ from: "indigo", to: "cyan" }),
    },
  },

  tabsList: {
    gap: theme.spacing.xl,
    width: "100%",
    maxWidth: 768,

    [theme.fn.smallerThan("md")]: {
      gap: theme.spacing.sm,
    },
  },
}))

export function DirectionTabs(): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Container size="xl" className={classes.inner}>
      <Tabs variant="pills" defaultValue="professions" radius="md">
        <Group position="center">
          <Tabs.List grow position="center" className={classes.tabsList}>
            {allEvents.map(({ title, value }) => (
              <Tabs.Tab className={classes.tab} key={value} value={value} fz="xl">
                {title}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Group>

        {allEvents.map(({ elements, title, value, buttonText, buttonLink, description }) => (
          <Tabs.Panel key={title} value={value}>
            <Group position="center">
              <Text p="xl" align="center" c="dimmed" className={classes.description}>
                {description}
              </Text>
            </Group>
            <SimpleGrid
              cols={3}
              spacing="xl"
              breakpoints={[
                { maxWidth: "lg", cols: 2 },
                { maxWidth: "md", cols: 1 },
              ]}
            >
              {elements.map((item, index) => (
                <DirectionCard key={index} {...item} />
              ))}
            </SimpleGrid>

            <Group position="center" className={classes.button}>
              <Button variant="light" radius="xl" size="md" component="a" target="_blank" href={buttonLink}>
                {buttonText}
              </Button>
            </Group>
          </Tabs.Panel>
        ))}
      </Tabs>
    </Container>
  )
}
